module.exports = __webpack_public_path__ + "static/media/rank-no-1.de1fe599.svg";